import React, {useState} from 'react'

function HeroBanner(props) {

  const [hideText] = useState(true)

  const versionNumber = '1.0'; // Define the version number here



  return (
    <div className='HeroBanner-Container'>
      <header>
      <picture>
        <source media='(min-width: 1300px)' srcSet={`/assets/HeroImageDesktop.png?v=${versionNumber}`} />
        <source media='(min-width: 500px)' srcSet={`/assets/HeroImageTablet.png?v=${versionNumber}`} />
       <img src={`/assets/HeroImageMobile.png?v=${versionNumber}`} alt="" />
      </picture>
      <div className='WebsiteName'>
        <h1 style={{display: hideText ? "block": 'none'}}>St. Michael The Archangel</h1>
        <h2 style={{display: hideText ? "block": 'none'}}>Catholic Church</h2>
      </div>
      </header>
    </div>
  )
}


export default HeroBanner
